"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["occasion", "employee", "isOccasionHasPassed", "isOccasionWasDeleted", "healthdeclarationTests", "occasionHasActualTime", "bookedTime", "employeeIsInOccasion", "pdfResults"],

  data: function data() {
    return {
      active: false,
      contacts: this.occasion.contact_information ? "email(" + this.occasion.contact_information.email + ") or " + ("phone(" + this.occasion.contact_information.phone + ").") : this.$t("common.messages.email")
    };
  },


  methods: {
    hasBookedTime: function hasBookedTime() {
      return !!this.bookedTime;
    },
    getDeleteBookingTimeLink: function getDeleteBookingTimeLink() {
      return "/occasion/" + this.occasion.id + "/employee/" + this.employee.id + "/time/" + this.bookedTime.id;
    },
    openBookTimeMenu: function openBookTimeMenu() {
      Fn.toggleMenu("book-time", this.occasion.id);
    },
    hasHealthdeclarationTest: function hasHealthdeclarationTest() {
      return this.healthdeclarationTests.length;
    },
    testsInOccasion: function testsInOccasion() {
      var _this = this;

      return _.sortBy(this.employee.dashboard_tests.filter(function (test) {
        return test.occasion_id === _this.occasion.id;
      }), "type_id");
    },
    healthDeclarationIsNotFilled: function healthDeclarationIsNotFilled(test) {
      return this.testsInOccasion().filter(function (userTest) {
        return userTest.type_id === test.id;
      }).length === 0;
    },
    getFormattedDate: function getFormattedDate(time) {
      return Fn.getFormattedDate(time);
    },
    deleteBooking: function deleteBooking(event) {
      var _this2 = this;

      event.preventDefault();
      this.$swal({
        text: this.$t("dashboard.deleteBookingConfirmation"),
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#85be39",
        cancelButtonColor: "#ef5350",
        confirmButtonText: this.$t("tests.messages.yes_answer"),
        cancelButtonText: this.$t("tests.messages.no_answer")
      }).then(function (result) {
        if (result.value) {
          _this2.$refs.deleteBookingForm.submit();
        }
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/dashboard/occasions/Actions.vue
// module id = wRdG
// module chunks = 1